import * as React from "react";
import { PrintInfo, CalendarState } from "burde";
import { getPublishedCalendarThemes } from "content/theme/service";
import { ZentaThemePicker, Theme } from "content/theme";
import { actionCreators as uiActionCreators } from "ui/store";
import { getCalendarStateFromPrintInfo } from "ui/helper";

type ThemeGalleryProps = {
    calendar: CalendarState;
    setActiveCalendar: (calendar?: CalendarState) => any;
} & typeof uiActionCreators;

interface ThemeGalleryState {
    selectedTheme: Theme | null;
    themes: Array<PrintInfo>;
}

class ThemeGallery extends React.Component<
    ThemeGalleryProps,
    ThemeGalleryState
> {
    _isMounted: boolean = false;

    public state: ThemeGalleryState = {
        selectedTheme: null,
        themes: [],
    };

    private changeTheme = (selectedTheme: Theme | null) => {
        const { setActiveCalendar } = this.props;

        this.setState({ selectedTheme: selectedTheme });

        if (selectedTheme === null) {
            setActiveCalendar(); // de-select any theme

            return;
        }

        const { themes } = this.state;

        const pickedTheme = selectedTheme
            ? (themes.find(
                  (t) => t.calendarId === selectedTheme.id,
              ) as PrintInfo)
            : undefined;

        if (pickedTheme !== undefined) {
            const calendarState = getCalendarStateFromPrintInfo(pickedTheme);

            setActiveCalendar({
                ...calendarState,
                // Make the calendar "new" to not override old theme
                isTheme: false,
                name: "",
            });
        }
    };

    componentDidMount() {
        this._isMounted = true;
        getPublishedCalendarThemes().then((themes) => {
            if (this._isMounted && themes) {
                this.setState({
                    themes,
                });
            }
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        const { themes, selectedTheme } = this.state;

        return (
            <div>
                <ZentaThemePicker
                    selectedTheme={selectedTheme}
                    themes={themes.map((t) => ({
                        id: t.calendarId,
                        name: t.name,
                        url: t.cover.customImage
                            ? t.cover.customImage.url
                            : t.cover.image
                            ? `/images/cover/${t.cover.image}?width=70&height=100`
                            : null,
                        color: t.cover.color,
                        published: true,
                    }))}
                    onClick={this.changeTheme}
                />
            </div>
        );
    }
}

export default ThemeGallery;
